import React from 'react'
import { twMerge } from 'tailwind-merge'
import { motion } from 'framer-motion'
import useMouse from '../hooks/useMouse'
import useWindowSize from '../hooks/useWindowSize'

export const mouseVariants = {
  default: 'bg-white/5 ring-[2px] ring-white/80 !aspect-square rounded-full mix-blend-exclusion',
  pointer: 'opacity-50 animate-pulse !ring-0 !bg-red-400   rounded-full',
  hover: 'bg-white/10',
  play: 'bg-white/10 animate-pulse ring-[2px] bg-white text-white',
  drag: 'bg-white/10 animate-pulse ring-[2px] bg-white text-white',
  see: '!bg-white animate-pulse ring-[2px] text-black'
}

const useCursor = () => {
  // & ZUSTAND
  const { onDesk } = useWindowSize();


  // & SETUP
  const { type } = useMouse();

  const isDefault = type === 'default'
  const isPointer = type === 'pointer'
  const isHover = type === 'hover'
  const isPlay = type === 'play'
  const isDrag = type === 'drag'
  const isSee = type === 'see'

  const MOUSE_W = isDefault
    ? 30
    : isPointer
      ? 50
      : isHover
        ? 50
        : isPlay
          ? 80
          : isDrag
            ? 100
            : isSee ?
              200
              : 30
  // const MOUSE_H = MOUSE_W

  let variant

  const mouseR = MOUSE_W

  // & LAYOUT
  const CursorLayout = ({ hasIcon, icon, type, mousePosition, ...props }) => {
    switch (type) {
      case 'play':
        variant = mouseVariants.play;
        hasIcon = true
        icon = 'ri-play-fill'
        break
      case 'hover':
        variant = mouseVariants.hover;
        icon = "!ri-arrow-right-s-line -rotate-45";
        break
      case 'drag':
        variant = mouseVariants.drag;
        icon = "!ri-arrow-right-s-line -rotate-45";
        
        break
      case 'pointer':
        variant = mouseVariants.pointer
        icon = "!ri-arrow-right-s-line -rotate-45";
        break
      case 'see':
        variant = mouseVariants.see
        icon = "-rotate-45";
        break
      case 'default':
        variant = mouseVariants.default;
        break
      default:
        variant = mouseVariants.default;
        // hasIcon = false
        break
    }

    const mouseSpring = {
      type: 'spring',
      stiffness: 300,
      damping: 20,
    }

    return (
      <motion.div
        style={{
          display: onDesk ? "flex" : "none",
          position: 'fixed',
          // width: mouseR,
          // height: mouseR,
          // transformOrigin: "50% 50%",
          zIndex: 300,
          left: mousePosition.x,
          top: mousePosition.y
        }}
        initial={{ width: 30, height: 30, scale: 1.5 }}
        animate={{
          width: MOUSE_W,
          height: MOUSE_W,
          scale: type === ("play" || "see" )? 1.5 : 1
        }}
        transition={mouseSpring}
        className={twMerge(
          'z-[300] pointer-events-none center !origin-top-left select-none items-center justify-center overflow-clip',
          variant
        )}
      >
        <div className='relative flex center full '>
          {isPointer && <i className={`flex center ri-xl ${icon || 'ri-arrow-right-s-line -rotate-45  animate-pulse mix-blend-difference'}`} />}
          {isPlay && <span className='font-light animate-slowfade !quicker flex full center text-sm'>
            <i className='ri-play-fill' />
            <i className='ri-pause-fill' />
          </span>}
          {isDrag && <span className='font-light animate-slowfade flex full center text-sm'>
            <i className='ri-drag-move-fill ri-xl' /> Scroll
          </span>}
          {isSee && <span className='font-light animate-slowfade flex full center text-sm'>
            <i style={{rotate: "45deg"}} className='ri-arrow-up-line  ri-3x animate-bounce' /> <h3>Voir</h3>
          </span>}
        </div>
      </motion.div>
    )
  }

  return {
    mouseR,
    CursorLayout
    // useMouse
  }
}

export default useCursor
